<template>
  <material-card
    :title="$t('components.plancreationwizard.plan_settings')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="settings"
    style="margin-top: 30px"
  >
    <v-card-text>
      <v-form
        ref="generalSettingsCheckboxes"
        v-model="valid"
        :disabled="disabled"
      >
        <v-layout row wrap>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <!-- <auto-select
              :value.sync="generalSettings.PlanSettings.BillingMode"
              :items="options.Enums.BillingMode"
              :label="$t('components.plancreationwizard.billing_mode')"
              :rules="[$rules.required]"
              :slots="true"
              :filter="filterFunc"
            >
              <template v-slot:selection="data">
                {{ $t("enums." + data.item) }}
              </template>
              <template v-slot:item="data">
                <v-list-item-content
                  v-text="$t('enums.' + data.item)"
                ></v-list-item-content>
              </template>
            </auto-select> -->
            <trans-enum
              :value.sync="generalSettings.PlanSettings.BillingMode"
              :items="options.Enums.BillingMode"
              :label="$t('components.plancreationwizard.billing_mode')"
              :rules="[$rules.required]"
              class="required"
            ></trans-enum>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              v-model="generalSettings.CertificateLength"
              :label="$t('components.plancreationwizard.certificate_length')"
              :rules="[$rules.requiredNum]"
              class="required"
              type="number"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.AutogenerateCertificate"
              :label="
                $t('components.plancreationwizard.autogenerate_certificates')
              "
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="generalSettings.AutogenerateCertificate"
          >
            <no-autocomplete-textfield
              v-model="generalSettings.StartingCertificateNumber"
              :label="$t('components.plancreationwizard.start_certificate')"
              :rules="[$rules.required, rules.certificate]"
              class="required"
              v-mask="certificateMask"
              :prefix="generalSettings.UniqueIdentifier"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasPremiums"
              :label="$t('components.plancreationwizard.include_premiums')"
              :rules="[rules.atLeastPremiumsOrRemittances]"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasBilling"
              :label="$t('views.plangeneralparameters.include_billing')"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="generalSettings.PlanSettings.HasBilling"
          >
            <v-checkbox
              v-model="
                generalSettings.PlanSettings.HasEmployerContributionsPerTerm
              "
              :label="
                $t(
                  'views.plangeneralparameters.employer_contributions_per_term'
                )
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasRemittances"
              :label="$t('components.plancreationwizard.include_remittances')"
              :rules="[rules.atLeastPremiumsOrRemittances]"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.IncludeTrustFund"
              :label="$t('components.plancreationwizard.include_trust_fund')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasOperatingFees"
              :label="
                $t('components.plancreationwizard.include_operating_fees')
              "
            ></v-checkbox>
          </v-col>
          <template v-if="generalSettings.PlanSettings.HasOperatingFees">
            <v-col sm="12" md="6">
              <no-autocomplete-textfield
                :label="$t('components.plancreationwizard.account_name')"
                :value="generalSettings.PlanSettings.OperatingFeesAccountName"
                @change="
                  generalSettings.PlanSettings.OperatingFeesAccountName = $event
                "
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-container pa-0>
                    <v-row no-gutters class="test">
                      <v-col cols="auto">
                        <v-checkbox
                          :class="$attrs['class']"
                          v-model="
                            generalSettings.PlanSettings.OperatingFeesPerTerm
                          "
                          :label="
                            $t(
                              'components.plancreationwizard.operating_fees_per_term'
                            )
                          "
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        style="margin-top: 20px; margin-left: 3px"
                        cols="auto"
                      >
                        <v-icon v-bind="attrs" v-on="on">help</v-icon>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <span>
                  {{
                    $t(
                      "components.plancreationwizard.operating_fees_per_term_tooltip"
                    )
                  }}
                </span>
              </v-tooltip>
            </v-col>
          </template>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasContributions"
              :label="$t('components.plancreationwizard.include_contributions')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasAdminFees"
              :label="$t('components.plancreationwizard.include_admin_fees')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              :class="$attrs['class']"
              v-model="generalSettings.PlanSettings.AdminFeesPerTerm"
              :label="
                          $t(
                            'components.plancreationwizard.admin_fees_per_term'
                          )
                        "
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasPlanFlatAdminFees"
              :label="$t('components.plancreationwizard.include_flat_admin_fees')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasPlanClaimAdminFees"
              :label="$t('components.plancreationwizard.include_claim_admin_fee')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasPaymentTracking"
              :label="
                $t('components.plancreationwizard.include_payment_tracking')
              "
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="generalSettings.PlanSettings.HasPaymentTracking"
          >
            <v-checkbox
              v-model="generalSettings.PlanSettings.TrackPerEmployer"
              :label="$t('components.plancreationwizard.track_per_employer')"
            ></v-checkbox>
          </v-col>
          <!-- <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasStores"
              :label="$t('components.plancreationwizard.include_stores')"
            ></v-checkbox>
          </v-col> -->
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.ReportsPerStore"
              :label="$t('components.plancreationwizard.reports_per_store')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasT4A"
              :label="$t('views.plangeneralparameters.include_t4a')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasDemographics"
              :label="
                $t('views.plangeneralparameters.include_demographics_report')
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasPremiumsCheqReqForm"
              :label="
                $t(
                  'views.plangeneralparameters.include_premiums_cheque_requisition_form'
                )
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasBeneficiaries"
              :label="$t('views.plangeneralparameters.has_beneficiaries')"
            ></v-checkbox>
          </v-col>

          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="
              generalSettings.PlanSettings.HasBeneficiaries &&
              generalSettings.PlanSettings.IncludeTrustFund
            "
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters>
                    <v-col>
                      <v-checkbox
                        v-model="
                          generalSettings.PlanSettings
                            .BeneficiaryStatementOnFund
                        "
                        :label="
                          $t(
                            'views.plangeneralparameters.beneficiary_statement_on_fund'
                          )
                        "
                      ></v-checkbox>
                    </v-col>
                    <v-col
                      style="margin-top: 20px; margin-left: 3px"
                      cols="auto"
                    >
                      <v-icon v-bind="attrs" v-on="on">help</v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{
                  $t(
                    "components.plancreationwizard.trust_fund_bebeficiaries_statement_tooltip"
                  )
                }}
              </span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="hasClasses"
              :label="$t('components.plancreationwizard.has_classes')"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-if="hasClasses"
            class="pt-0 pb-0"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters>
                    <v-col>
                      <v-combobox
                        :rules="[$rules.required]"
                        :value="classesStr.split(',').filter((e) => e)"
                        @input="classesStr = $event.filter((e) => e).join(',')"
                        hide-selected
                        :label="$t('components.plancreationwizard.classes')"
                        :hide-no-data="!inputClass"
                        :search-input.sync="inputClass"
                        multiple
                        small-chips
                      >
                        <template
                          v-slot:selection="{ attrs, item, parent, selected }"
                        >
                          <v-chip
                            v-bind="attrs"
                            color="primary"
                            :input-value="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item }}
                            </span>
                            <v-icon small @click="parent.selectItem(item)">
                              close
                            </v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col
                      style="margin-top: 20px; margin-left: 3px"
                      cols="auto"
                    >
                      <v-icon v-bind="attrs" v-on="on">help</v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{ $t("components.plancreationwizard.classes_tooltip") }}
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="hasOccupations"
              :label="$t('components.plancreationwizard.has_occupations')"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-if="hasOccupations"
            class="pt-0 pb-0"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-container pa-0>
                  <v-row no-gutters>
                    <v-col>
                      <v-combobox
                        :rules="[$rules.required]"
                        :value="occupationsStr.split(',').filter((e) => e)"
                        @input="
                          occupationsStr = $event.filter((e) => e).join(',')
                        "
                        hide-selected
                        :label="$t('components.plancreationwizard.occupations')"
                        :hide-no-data="!inputOccupations"
                        :search-input.sync="inputOccupations"
                        multiple
                        small-chips
                      >
                        <template
                          v-slot:selection="{ attrs, item, parent, selected }"
                        >
                          <v-chip
                            v-bind="attrs"
                            color="primary"
                            :input-value="selected"
                            label
                            small
                          >
                            <span class="pr-2">
                              {{ item }}
                            </span>
                            <v-icon small @click="parent.selectItem(item)">
                              close
                            </v-icon>
                          </v-chip>
                        </template>
                      </v-combobox>
                    </v-col>
                    <v-col
                      style="margin-top: 20px; margin-left: 3px"
                      cols="auto"
                    >
                      <v-icon v-bind="attrs" v-on="on">help</v-icon>
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <span>
                {{ $t("components.plancreationwizard.occupations_tooltip") }}
              </span>
            </v-tooltip>
          </v-col>

          <!-- <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.HasEligibility"
              :label="$t('components.plancreationwizard.include_eligibility')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.HasEligibilityBank"
              :label="$t('components.plancreationwizard.include_eligibility_bank')"
            ></v-checkbox>
          </v-col> -->
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasBillingImport"
              :label="
                $t('components.plancreationwizard.employer_contribution_import')
              "
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="generalSettings.PlanSettings.HasBillingImport"
          >
            <v-checkbox
              v-model="
                generalSettings.PlanSettings.MergeImportedAndCalculatedPremiums
              "
              :label="
                $t(
                  'components.plancreationwizard.merge_importred_and_calculated_premiums'
                )
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <trans-enum
              :value.sync="eligibilityType"
              :items="options.Enums.Eligibility"
              :label="$t('components.plancreationwizard.eligibility_type')"
              :rules="[$rules.required]"
              class="required"
            ></trans-enum>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              :disabled="!generalSettings.PlanSettings.HasBilling"
              v-model="generalSettings.TrackHours"
              :label="$t('components.plancreationwizard.track_hours')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.IncludeSelfPayments"
              :label="
                $t('components.plancreationwizard.track_member_self_payments')
              "
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasHealthSpendingAccount"
              :label="
                $t('views.plangeneralparameters.has_health_spending_account')
              "
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="pt-0 pb-0"
            v-if="generalSettings.PlanSettings.HasHealthSpendingAccount"
          >
            <no-autocomplete-textfield
              :label="$t('components.plancreationwizard.carry_forward_years')"
              v-model="generalSettings.PlanSettings.CarryForwardYears"
              :rules="[$rules.requiredNum]"
              class="required"
              type="number"
              min="0"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasSickPaymentBank"
              :label="$t('views.plangeneralparameters.has_sick_payment_bank')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.IncludeClaimsInDues"
              :label="$t('views.plangeneralparameters.include_claims_in_dues')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasBenefitYears"
              :label="$t('views.plangeneralparameters.has_benefit_years')"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.HasMemberPortal"
              :label="$t('views.plangeneralparameters.has_member_portal')"
            ></v-checkbox>
          </v-col>
          <template v-if="generalSettings.PlanSettings.HasMemberPortal">
            <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-container pa-0>
                    <v-row no-gutters>
                      <v-col>
                        <v-checkbox
                          v-model="generalSettings.PlanSettings.IsLegacyPortal"
                          :label="
                            $t('views.plangeneralparameters.legacy_portal')
                          "
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        style="margin-top: 20px; margin-left: 3px"
                        cols="auto"
                      >
                        <v-icon v-bind="attrs" v-on="on">help</v-icon>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <span>
                  {{
                    $t(
                      "components.plancreationwizard.has_member_portal_tooltip"
                    )
                  }}
                </span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
              <no-autocomplete-textfield
                :label="$t('components.plancreationwizard.portal_domain')"
                v-model="generalSettings.PlanSettings.PortalDomain"
                :rules="[$rules.required, $rules.url]"
                class="required"
              ></no-autocomplete-textfield>
            </v-col>
          </template>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <no-autocomplete-textfield
              :label="
                $t(
                  'components.plancreationwizard.members_registration_email_offset'
                )
              "
              v-model="generalSettings.RegistrationEmailSendDays"
              :rules="[$rules.integer]"
            ></no-autocomplete-textfield>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.PlanSettings.UseISeriesClaims"
              :label="$t('views.plangeneralparameters.use_legacy_claims')"
            ></v-checkbox>
          </v-col>
          <!-- <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
            <v-checkbox
              v-model="generalSettings.UseDocumentManagement"
              :label="
                $t('components.plancreationwizard.use_document_management')
              "
            ></v-checkbox>
          </v-col> -->
        </v-layout>
      </v-form>
    </v-card-text>
  </material-card>
</template>
<script>
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { mapGetters } from "vuex";
import TransEnum from "@/components/TransEnum.vue";
import { mask } from "vue-the-mask";

export default {
  components: { NoAutocompleteTextfield, TransEnum },
  props: ["generalSettings", "disabled"],
  directives: { mask },
  data() {
    return {
      inputClass: "",
      inputOccupations: "",
      hasClasses: false,
      hasOccupations: false,
      classesStr: "",
      occupationsStr: "",
      valid: false,
      rules: {
        atLeastPremiumsOrRemittances: () => {
          return (
            this.generalSettings.PlanSettings.HasPremiums === true ||
            this.generalSettings.PlanSettings.HasRemittances === true ||
            this.$t("validation.at_least_premiums_or_remittances")
          );
        },
        certificate: (v) => {
          console.log(v, this.generalSettings.CertificateLength-3)
          return !v || v.length === this.generalSettings.CertificateLength-3 || this.$t("validation.length_{0}", [this.generalSettings.CertificateLength]);
        },
      },
      certificateMask: "#",
      eligibilityType: null
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    eligibilityType: {
      handler(v) {
        if (v=="SmartEligibility") {
          this.generalSettings.HasEligibility = true;
          this.generalSettings.HasEligibilityBank = false;
        }
        else if (v=="EligibilityBank") {
          this.generalSettings.HasEligibility = false;
          this.generalSettings.HasEligibilityBank = true;
        }
        else {
          this.generalSettings.HasEligibility = false;
          this.generalSettings.HasEligibilityBank = false;
        }
      }
    },
    valid: {
      handler(v) {
        this.$emit("valid", v);
      },
    },
    hasClasses: {
      handler(v) {
        this.$emit("has-classes", v);
        if (!v) {
          this.classesStr = "";
        }
      },
    },
    hasOccupations: {
      handler(v) {
        this.$emit("has-occupations", v);
        if (!v) {
          this.occupationsStr = "";
        }
      },
    },
    classesStr: {
      handler(v) {
        this.$emit("update-classes", v);
      },
    },
    occupationsStr: {
      handler(v) {
        this.$emit("update-occupations", v);
      },
    },
    generalSettings: {
      handler(v) {
        if (v && v.PlanSettings.Classes) {
          this.hasClasses = true;
          this.classesStr = v.PlanSettings.Classes.replace(/\[/g, "")
            .replace(/\]/g, "")
            .replace(/"/g, "");
          this.classesArray = JSON.parse(
            this.generalSettings.PlanSettings.Classes
          );
        }
        if (v && v.Occupations) {
          this.hasOccupations = true;
          this.occupationsStr = v.Occupations.replace(/\[/g, "")
            .replace(/\]/g, "")
            .replace(/"/g, "");
        }
        if (v.CertificateLength) {
          let certificateMask = "";
          for (let i=0;i<v.CertificateLength-3;i++) {
            certificateMask+="#";
          }
          this.certificateMask = certificateMask;
        }
        if (v.HasEligibility) {
          this.eligibilityType = "SmartEligibility"
        } else if (v.HasEligibilityBank) {
          this.eligibilityType = "EligibilityBank"
        }
      },
      immediate: true,
    },
    "generalSettings.PlanSettings.HasPremiums": {
      handler(v) {
        this.$refs.generalSettingsCheckboxes.validate();
      },
    },
    "generalSettings.PlanSettings.HasBeneficiaries": {
      handler(v) {
        this.$emit("has-beneficiaries", v);
        if (!v) {
          this.generalSettings.PlanSettings.BeneficiaryStatementOnFund = false;
        }
      },
    },
    "generalSettings.PlanSettings.IncludeTrustFund": {
      handler(v) {
        if (!v) {
          this.generalSettings.PlanSettings.BeneficiaryStatementOnFund = false;
        }
      },
    },
    "generalSettings.PlanSettings.BeneficiaryStatementOnFund": {
      handler(v) {
        if (v) {
          this.$emit("beneficiary-statement-on-trustfund", v);
        }
      },
    },
    "generalSettings.PlanSettings.HasRemittances": {
      handler(v) {
        this.$refs.generalSettingsCheckboxes.validate();
      },
    },
    // "generalSettings.HasEligibility": {
    //   handler(v) {
    //     this.$emit("has-eligibility", v);
    //   },
    // },
    "generalSettings.PlanSettings.HasBilling": {
      handler(v) {
        if (!v) {
          this.generalSettings.TrackHours = false;
          this.generalSettings.PlanSettings.HasEmployerContributionsPerTerm = false;
        }
      },
    },
    "generalSettings.PlanSettings.HasOperatingFees": {
      handler(v) {
        if (!v) {
          delete this.generalSettings.PlanSettings.OperatingFeesAccountName;
          this.generalSettings.PlanSettings.OperatingFeesPerTerm = false;
        }
      },
    },
    "generalSettings.PlanSettings.HasPaymentTracking": {
      handler(v) {
        if (!v) {
          this.generalSettings.PlanSettings.TrackPerEmployer = false;
        }
      },
    },
    "generalSettings.PlanSettings.HasBillingImport": {
      handler(v) {
        if (!v) {
          this.generalSettings.PlanSettings.MergeImportedAndCalculatedPremiums = false;
        }
      },
    },
    "generalSettings.PlanSettings.HasMemberPortal": {
      handler(v) {
        if (!v) {
          this.generalSettings.PlanSettings.IsLegacyPortal = false;
          this.generalSettings.PlanSettings.PortalDomain = null;
        }
      },
    },
    "generalSettings.PlanSettings.HasHealthSpendingAccount": {
      handler(v) {
        if (!v) {
          this.generalSettings.PlanSettings.CarryForwardYears = null;
        }
      },
    },
    "generalSettings.CertificateLength": {
      handler(v) {
        console.log("###################cert len: ", v, !v);
          let certificateMask = "";
          for (let i=0;i<v-3;i++) {
            certificateMask+="#";
          }
          this.certificateMask = certificateMask;
          console.log(this.certificateMask);
          this.$refs.generalSettingsCheckboxes.validate();
      },
    },
  },
  methods: {
    atLeastPremiumsOrRemittances() {
      return (
        this.generalSettings.PlanSettings.HasPremiums === true ||
        this.generalSettings.PlanSettings.HasRemittances === true ||
        this.$t("validation.at_least_premiums_or_remittances")
      );
    },
  },
};
</script>
